import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { apiCall } from "../../services/authServieces";
import ShowSnackBar from "../../components/snackBar";
import Plus from "../../Assets/images/plus.png";
import React, { useState, useEffect } from "react";
import { useUIContext } from "../../context/index";
import "../../css/wb_manage_dealer.css";
import {
  AddUser,
  ChangePassword,
  deleteDealers,
  GetPinnacleUser,
  UpdateUser,
  GetAllAdmins,
} from "../../services/manageDealerService";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AlertDialog from "../../components/ConfirmDialog";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import { formatDate, getRandomNum } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SearchIcon from "@mui/icons-material/Search";
import LockResetIcon from "@mui/icons-material/LockReset";
import { ClipLoader } from "react-spinners";
import CountrySelect from "../../components/CountryPicker";


const WbManageDealer = () => {
  const { userType,userRights } = useUIContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [showCheck, setShowCheck] = useState(true);
  const [showWhatsappField, setShowWhatsappField] = useState(false);
  const [showCheckApi, setShowCheckApi] = useState(true);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [dealerCodeAvailable, setDealerCodeAvailable] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = React.useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [update, setUpdate] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState([]);
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
    const [regions, setRegions] = useState([]);
  const [zones, setZones] = useState([]);

  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogDescription, setDialogDescription] = useState("");
  const [ChangePasswordModal, setChangePasswordModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [allAdmins, setAllAdmins] = useState([]);

  const openDialog = (title, description) => {
    setDialogTitle(title);
    setDialogDescription(description);
    setOpen(true);
  };

  const [formValues, setFormValues] = useState({
    dealerCode: "",
    companyName: "",
    dealerName: "",
    tradeName: "",
    location: "",
    state: "",
    district: "",
    city: "",
    region: "",
    zone: "",
    uemail: "",
    mobile: "",
    status: "Activate",
    country: null,
    countryCode: '',
    adminId: '',
area:"",
main_dealer:'',
network_type:'',

  });
  const [formErrors, setFormErrors] = useState({});
  const [snackBar, setSnackBar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const baseColumns  = [
    { id: "company_name", label: "Company" },
    { id: "user_id", label: "Customer Id" },
    { id: "user_name", label: "Customer Name" },
    { id: "user_phone", label: "Mobile" },
    { id: "user_email", label: "Email Id" },
    { id: "created_date", label: "Created Date" },
    // { id: "trade_name", label: "Trade Name" },
    // { id: "location", label: "Location" },
    // { id: "city", label: "City" },
    // { id: "state", label: "State" },
    // { id: "zone", label: "Zone" },
    // { id: "status", label: "Status" },
    // { id: "action", label: "Action" },
  ];
  const columns = userType === "super_admin" && userRights.dealerWrite
  ? [...baseColumns, { id: "action", label: "Action" }]
  : baseColumns;

  // const handleEditModalToggle = () => setIsEditModalOpen(!isEditModalOpen);
  const handleAddModalToggle = async () => {
    try{
      setShowCheck(true);
      setUpdate(false);
      setFormValues({});
      setDealerCodeAvailable(false);
      const randomDealerCode = getRandomNum();
      setFormValues((prevValues) => ({
        ...prevValues,
        dealerCode: randomDealerCode.toString(),
      }));
      setUpdate(false);
      setFormErrors({});
      setIsAddModalOpen(!isAddModalOpen);
      const response = await GetAllAdmins();

      if (response?.success){
        setAllAdmins(response?.data ?? [])
        let apiData= response.regions
        const uniqueRegions = [...new Set(apiData.map((item) => item.dealer_region))];
        const uniqueZones = [...new Set(apiData.map((item) => item.dealer_zone))];
        setZones(uniqueZones)
    setRegions(uniqueRegions);

      }
    }catch(error){
      console.log('Error on loading all admins: ', error)
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "dealerCode") {
      setDealerCodeAvailable(false);
      setShowCheck(true);
    }

    if (name === "apiKey") {
      setShowCheckApi(true);
    }
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formValues.dealerCode) errors.dealerCode = "Dealer Code is required";
    if (!formValues.companyName)
      errors.companyName = "Company Name is required";
    if (!formValues.dealerName) errors.dealerName = "Dealer Name is required";
    if (!formValues.tradeName) errors.tradeName = "Trade Name is required";
    if (!formValues.location) errors.location = "Location is required";
    if (!formValues.state) errors.state = "State is required";
    if (!formValues.district) errors.district = "District is required";
    if (!formValues.city) errors.city = "City is required";
    if (!formValues.region) errors.region = "Region is required";
    if (!formValues.zone) errors.zone = "Zone is required";
    if (!formValues.uemail) errors.email = "Email is required";
    if (!formValues.mobile) errors.mobile = "Mobile is required";
    if (!formValues.country) errors.country = "Country is required";
    if (!formValues.adminId) errors.adminId = "Admin Name is required";
    if (!formValues.network_type) errors.adminId = "Network Type is required";
    if (!formValues.main_dealer) errors.adminId = "Main Dealer Code is required";
    if (!update) {
      if (!formValues.upassword) errors.password = "Password is required";
    }
    setFormErrors(errors, Object.keys(errors).length === 0);
    return Object.keys(errors).length === 0;
  };

  const handleChangePage = async (event, newPage) => {
    const updatedPage = newPage + 1;
    await fetchUsers(updatedPage, rowsPerPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    await fetchUsers(page, parseInt(event.target.value));
  };

  const handleClick = (event, row) => {
   
  
    setAnchorEl(event.currentTarget);
    
    setSelectedRow(row);


  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleConfirm = async () => {
    await deleteDealer(selectedRow?.id);
  };

  // Example cancel action
  const handleCancel = () => {
    console.log("Rejected");
  };

  const handleMenuAction = async (action) => {
    if (action === "delete") {
      openDialog(
        "Delete Confirmation",
        "Are you sure you want to delete this item?"
      );
    }

    if (action === "manage-waba") {
      navigate("/admin/manage-waba", { state: { selectedRow } });
    }

    if (action === "edit") {
      let responseRegionZone = await apiCall({
        endpoint:"api/manage-users/get-all-zones-region",
        method:"GET",
      })

      if(responseRegionZone.success){
 let apiData= responseRegionZone.regions
        const uniqueRegions = [...new Set(apiData.map((item) => item.dealer_region))];
        const uniqueZones = [...new Set(apiData.map((item) => item.dealer_zone))];
        setZones(uniqueZones)
    setRegions(uniqueRegions);
      }else{
        alert("Error When Fetch Data")
      }

 



      setFormValues((prevValues) => ({
        ...prevValues,
        dealerCode: "",
      }));




      setDealerCodeAvailable(true);
      setShowCheck(false);
      setUpdate(true);
      patchValues(selectedRow);
      setIsAddModalOpen(true);
      const response = await GetAllAdmins();
      if (response?.success){
        setAllAdmins(response?.data ?? [])
      }
    }
    if (action === "changePassword") {
      setShowCheck(false);
      setChangePasswordModal(true);
    }

    handleClose();
  };

  const modalClose = () => {
    setUpdate(false);
    setShowCheck(true);
    setFormErrors({});
    setFormValues({});
    setIsAddModalOpen(!isAddModalOpen);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // setSelectedRow(null);
  };

  const fetchUsers = async (page = 1, limit = 10, query = "") => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/manage-users/get-users?page=${page}&limit=${limit}&search=${query}`,
        method: "GET",
      });
      if (res?.success) {
        setRows(res?.data || []);
  
        setCount(res?.total);
      }
    } catch (err) {
      setSnackBar({
        open: true,
        severity: false,
        message: err?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 1500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedQuery) {
      fetchUsers(1, 10, debouncedQuery);
    } else {
      fetchUsers();
    }
  }, [debouncedQuery]);



  const getDealer = async (dealerCode) => {
    setLoading(true);
    try {
      const res = await apiCall({
        endpoint: `api/manage-users/get-dealer/${dealerCode}`,
        method: "GET",
      });


   
      if (res?.message=="Dealer Not Found!.") {
       

   setFormValues({
          region:res.dealer_data.region,
          dealerCode:res.dealer_data.dealer_code,
          zone:res.dealer_data.zone,
          area:res.dealer_data.area,
          network_type:res.dealer_data.network_type,
          main_dealer:res.dealer_data.main_dealer,
          city:res.dealer_data.city,
          state:res.dealer_data.state,
          
         })
         setDealerCodeAvailable(true);
      
        
      }
    } catch (err) {
    
      setDealerCodeAvailable(true);
    } finally {
     
      setLoading(false);
    }
  };

  const deleteDealer = async (dealerCode) => {
    setLoading(true);
    try {
      const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
      await deleteDealers(dealerCode, showSnackBar);
      const newRows = rows.filter((el) => el.id !== dealerCode);
      setCount(newRows.length);
      setRows(newRows);
    } catch (error) {
      console.log('Error on deleting file: ', error);
    } finally {
      setLoading(false);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      let res = "";
      const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
      if (update) {

        res = await UpdateUser(selectedRow?.id, formValues, showSnackBar);
      } else {
        res = await AddUser(formValues, showSnackBar);
      }
      if (res?.success) {
        setIsAddModalOpen(false);
        setFormErrors({});
        setFormValues({});
        await fetchUsers();
      }
    }
  };
  const patchValues = (data) => {
    if (data) {
      setFormValues({
        dealerCode: data.user_id || formValues.dealerCode,
        companyName: data.company_name || formValues.companyName,
        dealerName: data.user_name || formValues.dealerName,
        tradeName: data.tradeName || formValues.tradeName,
        location: data.location || formValues.location,
        state: data.state || formValues.state,
        district: data.district || formValues.district,
        city: data.city || formValues.city,
        region: data.region || formValues.region,
        zone: data.zone || formValues.zone,
        uemail: data.user_email || formValues.uemail,
        mobile: data.user_phone || formValues.mobile,
        status: data?.status || formValues.status,
        country: data.country || formValues.country,
        countryCode: data.country_mob_code || formValues.countryCode,
        adminId: data.adminId || formValues.adminId,
        area: data.area || formValues.area,
        main_dealer: data.main_dealer || formValues.main_dealer,
        zone: data.zone || formValues.zone,
        network_type: data.network_type || formValues.network_type,
        region: data.region || formValues.region,

      });

      
      
    }
  };

  const checkDealer = async (e) => {
    e.preventDefault();

    // Validate dealerCode
    if (!formValues?.dealerCode) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Dealer Code is required",
      }));
      return;
    }

    if (!formValues?.dealerCode) {
      // Assuming dealer code should be 6 digits
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Please enter dealer code",
      }));
      return;
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      dealerCode: null,
    }));

    const dealerCode = formValues?.dealerCode;
    const data = await getDealer(dealerCode);
    if (data) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        dealerCode: "Dealer Already exists",
      }));
      setShowCheck(false);
    } else {
      setDealerCodeAvailable(true);
    }
  };


  const checkApiKey = async (e) => {
    e.preventDefault();

    if (!formValues.UserServer) {
      return;
    }

    const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
    const apiKey = formValues.apiKey;
    const res = await GetPinnacleUser(apiKey, showSnackBar);
    if (res && res?.data?.length) {
      setShowWhatsappField(true);
      setShowCheckApi(false);
      setFormValues({
        ...formValues,
        whatsappBusinessAccountId: res?.data?.[0].whatsapp_business_account_id, // Direct property name
      });
    } else {
      setShowWhatsappField(false);
      setShowCheckApi(true);
      setFormValues({
        ...formValues,
        whatsappBusinessAccountId: "", // Direct property name
      });
    }
  };

  const handlePasswordInput = (e) => {
    const { id, value } = e.target;
    setPasswords({
      ...passwords,
      [id]: value,
    });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { password, confirmPassword } = passwords;

      if (password === "" || confirmPassword === "") {
        setErrorMessage("Both fields are required");
        return;
      }
      if (password !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return;
      }
      if (selectedRow?.user_id) {
        const showSnackBar = (snackBarData) => setSnackBar(snackBarData);
        const res = await ChangePassword(
          selectedRow.user_id,
          passwords,
          showSnackBar
        );
        if (res?.success) {
          setChangePasswordModal(false);
          setPasswords({});
          setErrorMessage("");
        }
      }
    } catch (err) {
      setChangePasswordModal(false);
      setErrorMessage("");
      setSnackBar({
        open: true,
        severity: false,
        message: err?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  const onCountryChange = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value?.label || prevValues.country,
      countryCode: value?.phone
    }));

  }


    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="Template_id_contian">
        <h4 className="Head_title AdminSearchContain" style={{paddingLeft:"400px"}}>
          Dealer Details
          <div
            className={`Session_report_SearchContain user_details_search ${userType === "super_admin"  && userRights.dealerWrite ? "with-new-btn" : "no-new-btn"
              }`}
          >
            <input
              placeholder="Search"
              type="text"
              value={searchQuery}
              onChange={handleSearch}
            />
            <button type="button">
              <SearchIcon />
            </button>

          </div>
          {userType === "super_admin" && userRights.dealerWrite && (
            <button className="add_btn6" onClick={handleAddModalToggle}>
              <img src={Plus} alt="img" /> New
            </button>
          )}
        </h4>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" className="Table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "created_date" ? (
                              value
                            ) : column.id === "action" && userType === "super_admin" ? (

                              <>
                                <IconButton
                                  aria-controls="simple-menu"
                                  aria-haspopup="true"
                                  onClick={(event) => handleClick(event, row)}
                                >
                                  <MoreVertIcon />
                                </IconButton>
                                <Menu
                                  id="simple-menu"
                                  anchorEl={anchorEl}
                                  keepMounted
                                  open={Boolean(anchorEl)}
                                  onClose={handleClose}
                                  className="BoxShadowNone"
                                >
                                  <MenuItem
                                    onClick={() => handleMenuAction("edit")}
                                  >
                                    <EditIcon className="icon-spacing" />
                                    Edit
                                  </MenuItem>
                                  {/* <MenuItem
                                    onClick={() =>
                                      handleMenuAction("manage-waba")
                                    }
                                  >
                                    <ManageAccountsIcon className="icon-spacing" />
                                    Manage Waba
                                  </MenuItem> */}
                                  <MenuItem
                                    onClick={() => handleMenuAction("delete")}
                                  >
                                    <DeleteForeverIcon className="icon-spacing" />
                                    Delete
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      handleMenuAction("changePassword")
                                    }
                                  >
                                    <LockResetIcon className="icon-spacing" />
                                    Change Password
                                  </MenuItem>
                                </Menu>
                                {ChangePasswordModal ? (
                                  <div className="DChangePasswordModalContain">
                                    <div className="DChangePasswordModal">
                                      <h4>Change Password</h4>
                                      <form onSubmit={handlePasswordSubmit}>
                                        <div className="DFormgroupContain">
                                          <div className="DFormgroup">
                                            <label htmlFor="password">
                                              Password
                                            </label>
                                            <input
                                              type="password"
                                              id="password"
                                              placeholder="Enter Your Password"
                                              value={passwords.password}
                                              onChange={handlePasswordInput}
                                            />
                                          </div>
                                          <div className="DFormgroup">
                                            <label htmlFor="cpassword">
                                              Confirm Password
                                            </label>
                                            <input
                                              type="password"
                                              id="confirmPassword"
                                              placeholder="Enter Your Password"
                                              value={passwords.confirmPassword}
                                              onChange={handlePasswordInput}
                                            />
                                          </div>
                                          {errorMessage && (
                                            <p className="error">
                                              {errorMessage}
                                            </p>
                                          )}
                                          <div className="DFormgroup">
                                            <button
                                              type="submit"
                                              className="save"
                                            >
                                              Save
                                            </button>
                                            <button
                                              type="button"
                                              className="cancel ms-2"
                                              onClick={() => {
                                                setChangePasswordModal(false);
                                                setPasswords({});
                                                setErrorMessage("");
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : column.format && typeof value === "number" ? (
                              column.format(value)
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      {isAddModalOpen && (
        <div className="modal fade show d-block manage_dealer_form wb_mange_content">
          <div className="modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {update ? "Update Dealer" : "Add Dealer"}
                </h5>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-container">

                    {/* <div className="form-group">
                      <label htmlFor="UserServer">
                        User Server <span className="required_icon">*</span>

                      </label>
                      <select
                        name="UserServer"
                        value={formValues.UserServer || ""}
                        onChange={handleInputChange}
                      // disabled={update}
                      >
                        <option value="" disabled>Select Server</option>
                        <option value="Karix">Karix</option>
                        <option value="Pinnacle">Pinnacle</option>
                      </select>

                    </div> */}
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="dealerCode">
                          Dealer Code <span className="required_icon">*</span>
                        </label>
                        <>
                          <input
                            type="text"
                            name="dealerCode"
                            placeholder="Enter Dealer Code"
                            value={formValues.dealerCode || ""}
                            onChange={handleInputChange}
                            readOnly={update}
                          />
                          {formErrors.dealerCode && (
                            <span className="error">
                              {formErrors.dealerCode}
                            </span>
                          )}
                          {showCheck && !update && (
                            <>
                              {!dealerCodeAvailable ? (
                                <button
                                  onClick={checkDealer}
                                  className="check-dealer-button bg_blue"
                                >
                                  Check
                                </button>
                              ) : (
                                <p
                                  style={{ color: "green" }}
                                  className="validation_green"
                                >
                                  Dealer code available
                                </p>
                              )}
                            </>
                          )}
                        </>
                      </div>
                      <div className="form-group">
                        <label htmlFor="companyName">
                          Company Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="companyName"
                          placeholder="Enter Company Name"
                          value={formValues.companyName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.companyName && (
                          <span className="error">
                            {formErrors.companyName}
                          </span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="dealerName">
                          Dealer Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="dealerName"
                          placeholder="Enter Dealer Name"
                          value={formValues.dealerName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.dealerName && (
                          <span className="error">{formErrors.dealerName}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="admin">
                          Admin Name <span className="required_icon">*</span>
                        </label>
                        
                        <select
                          name="adminId"
                          value={formValues.adminId || ""}
                          onChange={handleInputChange}
                        >
                          <option value="" disabled>Select Admin</option>
                          {console.log(allAdmins, " got my all admins")}
                          {allAdmins.map((admin, index) => (
                            <option value={admin.user_id} key={index}>{admin.user_name}</option>
                          ))}
                        </select>
                        {formErrors.adminId && (
                          <span className="error">{formErrors.adminId}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="uemail">
                          Email <span className="required_icon">*</span>
                        </label>
                        <input
                          type="email"
                          name="uemail"
                          placeholder="Enter Email"
                          value={formValues.uemail}
                          onChange={handleInputChange}
                        />
                        {formErrors.email && (
                          <span className="error">{formErrors.email}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="mobile">
                          Mobile <span className="required_icon">*</span>
                        </label>
                        <input
                          type="tel"
                          name="mobile"
                          placeholder="Enter Mobile"
                          value={formValues.mobile}
                          onChange={handleInputChange}
                        />
                        {formErrors.mobile && (
                          <span className="error">{formErrors.mobile}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">

                      {/* Zone Dropdown */}
      <div className="form-group">
        <label htmlFor="zone">
          Zone <span className="required_icon">*</span>
        </label>
        <select
          name="zone"
          value={formValues.zone || ""}
          onChange={handleChange}
          disabled={!formValues.region} // region select nahi hai to disable
        >
          <option value="">Select Zone</option>
          {zones.map((zone, index) => (
            <option key={index} value={zone}>
              {zone}
            </option>
          ))}
        </select>
        {formErrors.zone && <span className="error">{formErrors.zone}</span>}
      </div>

                      {!update && (
                        <div className="form-group">
                          <label htmlFor="upassword">
                            Password <span className="required_icon">*</span>
                          </label>
                          <input
                            type={isPasswordVisible ? "text" : "password"}
                            name="upassword"
                            placeholder="Enter Password"
                            value={formValues.upassword || ""}
                            onChange={handleInputChange}
                          />
                          <button
                            type="button"
                            className="PSIcon"
                            onClick={togglePasswordVisibility}
                          >
                            {isPasswordVisible ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </button>
                        </div>
                      )}
                      <div className="form-group">
                        <label htmlFor="location">
                          Country <span className="required_icon">*</span>
                        </label>
                        <CountrySelect className='CountrySelect' onCountryChange={onCountryChange} value={{ label: formValues.country }}></CountrySelect>
                        {formErrors.country && (
                          <span className="error">{formErrors.country}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="location">
                          Location <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="location"
                          placeholder="Enter Location"
                          value={formValues.location}
                          onChange={handleInputChange}
                        />
                        {formErrors.location && (
                          <span className="error">{formErrors.location}</span>
                        )}
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="state">
                          State <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="state"
                          placeholder="Enter State"
                          value={formValues.state}
                          onChange={handleInputChange}
                        />
                        {formErrors.state && (
                          <span className="error">{formErrors.state}</span>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="district">
                          District <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="district"
                          placeholder="Enter District"
                          value={formValues.district}
                          onChange={handleInputChange}
                        />
                        {formErrors.district && (
                          <span className="error">{formErrors.district}</span>
                        )}
                      </div>

                   
                      <div className="form-group">
                        <label htmlFor="city">
                          City <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="city"
                          placeholder="Enter City"
                          value={formValues.city}
                          onChange={handleInputChange}
                        />
                        {formErrors.city && (
                          <span className="error">{formErrors.city}</span>
                        )}
                      </div>


                             <div className="form-group">
                        <label htmlFor="tradeName">
                          Trade Name <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="tradeName"
                          placeholder="Enter Trade Name"
                          value={formValues.tradeName || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.tradeName && (
                          <span className="error">{formErrors.tradeName}</span>
                        )}
                      </div>

                    </div>
                    <div className="form-row">
                         <div className="form-group">
        <label htmlFor="region">
          Region <span className="required_icon">*</span>
        </label>
        <select
          name="region"
          value={formValues.region || ""}
          onChange={handleChange}
        >
          <option value="">Select Region</option>
          {regions.map((region, index) => (
            <option key={index} value={region}>
              {region}
            </option>
          ))}
        </select>
        {formErrors.region && <span className="error">{formErrors.region}</span>}
      </div>




                       <div className="form-group">
                        <label htmlFor="area">
                          Area <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="area"
                          placeholder="Enter Area"
                          value={formValues.area}
                          onChange={handleInputChange}
                        />
                        {formErrors.area && (
                          <span className="error">{formErrors.area}</span>
                        )}
                      </div>
                  



                       <div className="form-group">
                        <label htmlFor="main_dealer">
                          Main Dealer Code <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="main_dealer"
                          placeholder="Enter Main Dealer Name"
                          value={formValues.main_dealer || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.mainDealerCode && (
                          <span className="error">{formErrors.main_dealer}</span>
                        )}
                      </div>




                       <div className="form-group">
                        <label htmlFor="networkType">
                          Network Type <span className="required_icon">*</span>
                        </label>
                        <input
                          type="text"
                          name="network_type"
                          placeholder="Enter Network Type "
                          value={formValues.network_type || ""}
                          onChange={handleInputChange}
                        />
                        {formErrors.networkType && (
                          <span className="error">{formErrors.network_type}</span>
                        )}
                      </div>



                      {/* {(showWhatsappField || formValues.UserServer === "Karix" || update) && (
                        <div className="form-group">
                          <label htmlFor="whatsappBusinessAccountId">
                            WhatsApp Business Account ID{" "}
                            <span className="required_icon">*</span>
                          </label>
                          <input
                            type="text"
                            name="whatsappBusinessAccountId"
                            placeholder="Enter WhatsApp Business Account ID"
                            value={formValues.whatsappBusinessAccountId || ""}
                            onChange={handleInputChange}
                            readOnly={formValues.UserServer !== "Karix"}
                          />
                          {formErrors.whatsappBusinessAccountId && (
                            <span className="error">
                              {formErrors.whatsappBusinessAccountId}
                            </span>
                          )}
                        </div>
                      )} */}
                      <div className="form-group">
                        <label htmlFor="status">
                          Status <span className="required_icon">*</span>
                        </label>
                        <select
                          name="status"
                          value={formValues.status || ""}
                          onChange={handleInputChange}
                        >
                          <option value={formValues.status || "Activate"}>
                            {formValues.status || "Activate"}
                          </option>
                          <option value="Activate">Activate</option>
                          <option value="Deactivate">Deactivate</option>
                        </select>
                        {formErrors.status && (
                          <span className="error">{formErrors.status}</span>
                        )}
                      </div>
                    </div>

                    {/* <div className="form-row">

                      <div className="form-group">
                        <label htmlFor="oem_dealer">
                          Oem DealerCode
                        </label>
                        <input
                          type="text"
                          name="oem_dealer"
                          placeholder="Enter Dealercode"
                          value={formValues.oem_dealer}
                          onChange={handleInputChange}
                        />

                      </div>

                      <div className="form-group">
                        <label htmlFor="oem_id"> OEM ID </label>
                        <input
                          type="text"
                          name="oem_id"
                          placeholder="Enter OEM ID"
                          value={formValues.oem_id || ""}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div> */}
                  </div>
                  <div className="modal-footer">
                    {dealerCodeAvailable && <button type="submit" className="btn btn-primary">
                      {update ? "Update" : "Save"}
                    </button>}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={modalClose}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}

      <AlertDialog
        open={open}
        setOpen={setOpen}
        title={dialogTitle}
        description={dialogDescription}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />
    </>
  );
};

export default WbManageDealer;
